module.exports = __webpack_public_path__ + "img/Icon - Communication.bf317c2a.png";